import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/Login'
import home from '@/components/home'
import logout from '@/components/logout'
import page404 from '@/components/page404'
import general_settings from '@/components/general/general-settings'
import uom_master_view from '@/components/app-pages/uom-master/uom-master-view'
import uom_master_conversion_view from '@/components/app-pages/uom-master-conversion/uom-master-conversion-view'
import customers from '@/components/customers'
import customerprofile from '@/components/customer_profile'
import addorder from '@/components/addorder'
import itemprofile from '@/components/itemprofile'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/home',
      name: 'home',
      component: home
    },
    {
      path: '/logout',
      name: 'logout',
      component: logout
    },    
    {
      path: '/customers',
      name: 'customers',
      component: customers
    },    
    {
      path: '/customer-profile',
      name: 'customerprofile',
      component: customerprofile
    },    
    {
      path: '/addorder',
      name: 'addorder',
      component: addorder
    },    
    {
      path: '/itemprofile',
      name: 'itemprofile',
      component: itemprofile
    },    
    {
      path: '/uom-master-conversion',
      name: 'uom_master_conversion_view',
      component: uom_master_conversion_view
    },
    {
      path: '*',
      name: 'page404',
      component: page404
    }      
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js